import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        this.element.addEventListener('change', function (e) {
            const targets = document.querySelectorAll(e.target.dataset.targets);
            const filterFields = document.querySelectorAll(e.target.dataset.filterFields);
            const value = e.target.value.replaceAll(/\s/g, '');
            const values = [];

            if (filterFields !== undefined && filterFields.length > 0) {
                for (const field of filterFields) {
                    if (field.value === 'all') {
                        continue;
                    }
                    values.push(`.${field.value.replaceAll(/\s/g, '')}`);
                }

                if (values.length <= 0) {
                    this.showAll(targets);
                }

                for (const el of targets) {
                    if (el.matches(values.join(''))) {
                        el.classList.remove('d-none');
                    } else {
                        el.classList.add('d-none');
                    }
                }
            } else {
                if (value === 'all') {
                    this.showAll(targets);
                } else {
                    for (const el of targets) {
                        if (el.classList.contains(value)) {
                            el.classList.remove('d-none');
                        } else {
                            el.classList.add('d-none');
                        }
                    }
                }
            }
        }.bind(this));
    }

    showAll(targets) {
        for (const el of targets) {
            el.classList.remove('d-none');
        }
    }
}
